import EditorEmailSimpleView from './EditorEmailSimpleView'

export default EditorEmailSimpleView
